import React from 'react'

function ErrorScreen() {
    return (
        <div>
            ERRORE
        </div>
    )
}

export default ErrorScreen
